var message = null;

(function ($) {
    'use_strict';
    
    $(window).bind("load", set_timout);
    $(document).on("stripeError", set_timout);
    $(document).on("showMessage",set_timout);

    function set_timout() {
        setTimeout(show_hide_msg, 1);  
    }

    function show_hide_msg(evt) {
        $("body").find(".m4-msg").each(function () {
            $(this).appendTo("body"); 
            $(this).hide();
            $(this).slideDown(800, function () {  
                $(this).delay("4000").slideUp(800, function () { 
                    //$(this).remove();  
               });
            });
        });
    }
    
    message = function(_type){
        
        var self = this;
        self.msg = null;
        self.container = null;
        self.ul = null;
        self.type = _type;
        
        self.init = function(){
            
            self.container = $('<div/>',{
               class : "m4-msg" 
            }).hide();
            
            self.alert = $('<div/>',{
               class : 'alert alert-dismissible alert-' + self.type,
               role : 'alert',
               html : '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
            });
            
            self.ul = $('<ul/>');
            self.alert.append(self.ul); 
            self.container.append(self.alert); 
        };
        
        self.createMessage = function(_html){ 
            var li = $('<li/>',{
               html : _html
            });
            
            self.removeAllMsg();              
            self.ul.append(li);   
        };
        
        self.removeAllMsg = function(){ 
          self.ul.html(" ");    
        };
        
        self.remove_msg = function(li){
            self.conatiner.find(li).remove();
        };
        
        self.destroy = function(){
            self.container.remove();
        };
        
        self.display = function(){
            $("body").append(self.container); 
            $(document).trigger("showMessage");  
        };
        
        self.init(); 
        
        return self;
    };
    
})(jQuery, window, document); 